import React, { useState, useMemo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import {
  obtenerCatalogoMaguey,
  obtenerTrazabilidadAsociado,
  obtenerMaduracionPorLogin,
  registrarMaduracionAsociado
} from "../../../redux/DucksBeneficiario/BitacoraProduccionDucks";
import "./BitacoraEnvasado.css";

// Material UI Icons
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import LocalBarIcon from '@mui/icons-material/LocalBar';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import ScienceIcon from '@mui/icons-material/Science';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import DeviceThermostatIcon from '@mui/icons-material/DeviceThermostat';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';

// Subcomponents
import InventarioGranelSection from "./BitacoraEnvasado/InventarioGranelSection";
import EnvasadoNoTerminadoSection from "./BitacoraEnvasado/EnvasadoNoTerminadoSection";
import EnvasadoTerminadoSection from "./BitacoraEnvasado/EnvasadoTerminadoSection";
import ControlHologramasSection from "./BitacoraEnvasado/ControlHologramasSection";
import ElaboracionClasesSection from "./BitacoraEnvasado/ElaboracionClasesSection";
import InventarioMaduracionSection from "./BitacoraEnvasado/InventarioMaduracionSection";
import CondicionesMaduracionSection from "./BitacoraEnvasado/CondicionesMaduracionSection";
import QuejasSection from "./BitacoraEnvasado/QuejasSection";

const BitacoraEnvasado = () => {
  const dispatch = useDispatch();

  // Obtener usuario autenticado e id_login (id: 3462)
  const usuarioData = useSelector(state => state.Usuario?.data || state.Usuario || null);
  const idLogin = usuarioData?.user?.[0]?.id ||
    usuarioData?.user?.id ||
    usuarioData?.idlogin ||
    usuarioData?.id_login ||
    usuarioData?.id ||
    null;

  const reduxTrazabilidadLots = useSelector(state => state.bitacoraProduccion?.trazabilidadLots || []);
  const reduxCatalogoMaguey = useSelector(state => state.bitacoraProduccion?.catalogoMaguey || []);
  const reduxMaduracionRecords = useSelector(state => state.bitacoraProduccion?.maduracionRecords || []);

  // Batch selector
  const [activeBatch, setActiveBatch] = useState("Lote 01-ENV-2026");
  const [showBatchDropdown, setShowBatchDropdown] = useState(false);
  const batches = ["Lote 01-ENV-2026", "Lote 02-ENV-2026", "Lote 03-ENV-2026"];

  // Tab navigation state
  const [activeTab, setActiveTab] = useState(0);
  const [isFormOpen, setIsFormOpen] = useState(false);

  useEffect(() => {
    dispatch(obtenerCatalogoMaguey());
    if (idLogin) {
      dispatch(obtenerTrazabilidadAsociado({ id_login: idLogin }));
      dispatch(obtenerMaduracionPorLogin(idLogin));
    }
  }, [dispatch, idLogin]);

  useEffect(() => {
    if (activeTab === 5 && idLogin) {
      dispatch(obtenerMaduracionPorLogin(idLogin));
    }
  }, [activeTab, idLogin, dispatch]);

  const tabsInfo = [
    { id: 0, title: "Sección II", name: "Granel", desc: "Inventarios de Mezcal a Granel", icon: LocalBarIcon, shortLabel: "II. Granel", theme: "status-cierre" },
    { id: 1, title: "Sección III", name: "Envasado No Terminado", desc: "Inventario de botellas sin etiquetar", icon: ShoppingBagIcon, shortLabel: "III. No Terminado", theme: "status-coccion" },
    { id: 2, title: "Sección IV", name: "Envasado Terminado", desc: "Inventario de botellas con holograma", icon: WorkspacePremiumIcon, shortLabel: "IV. Terminado", theme: "status-elaboracion" },
    { id: 3, title: "Sección V", name: "Hologramas", desc: "Control del Inventario de Hologramas", icon: ConfirmationNumberIcon, shortLabel: "V. Hologramas", theme: "status-maduracion" },
    { id: 4, title: "Sección VI", name: "Elaboración de Clases", desc: "Abocado, destilado con o reprocesos", icon: ScienceIcon, shortLabel: "VI. Clases", theme: "status-elaboracion" },
    { id: 5, title: "Sección VII", name: "Maduración", desc: "Inventarios en Maduración", icon: HourglassBottomIcon, shortLabel: "VII. Maduración", theme: "status-maduracion" },
    { id: 6, title: "Sección VIII", name: "Condiciones", desc: "Registro de Condiciones", icon: DeviceThermostatIcon, shortLabel: "VIII. Condiciones", theme: "status-cierre" },
    { id: 7, title: "Sección IX", name: "Quejas", desc: "Quejas del Producto Certificado", icon: ReportProblemIcon, shortLabel: "IX. Quejas", theme: "status-coccion" }
  ];

  // ================= DATA HISTORY STATES =================
  const [granelRecords, setGranelRecords] = useState([
    {
      id: "GRA-ENV-01",
      fechaMovimiento: "2026-09-22",
      fecha: "2026-09-22",
      idContenedor: "-",
      no_tanque: "-",
      noLote: "nuev123",
      no_lote: "nuev123",
      noProduccion: "nuev123",
      categoria: "Mezcal Artesanal",
      clase: "Blanco Joven",
      materiaPrima: "Agave americana (MAGUEY SIERRUDO), Agave angustifolia (MAGUEY ESPADÍN)",
      tipoMaguey: "Agave americana (MAGUEY SIERRUDO), Agave angustifolia (MAGUEY ESPADÍN)",
      especie: "Agave americana (MAGUEY SIERRUDO), Agave angustifolia (MAGUEY ESPADÍN)",
      ingrediente: "",
      ingredientes: "",
      edad: "Sin edad",
      noAnalisis: "-",
      noAnalisisFisicoquimico: "-",
      clave_fq: "-",
      litros: 225,
      porcentaje_alc_vol: 48.5,
      invInicialVol: "225",
      invInicialAlc: "48.5",
      entradaProcedencia: "Destilación Lote nuev123",
      entradaVolumen: "225",
      entradaAlc: "48.5",
      entradaVolAgua: "0",
      salidaVolumen: "0",
      salidaAlc: "0",
      salidaDestino: "",
      invFinalVol: "225",
      invFinalAlc: "48.5",
      observaciones: "Ingreso a inventario de mezcal a granel.",
      inspector: "Ing. Carlos Mendoza (UI Autorizado)",
      status: "aprobado",
      statusUI: "aprobado"
    },
    {
      id: "GRA-ENV-02",
      fechaMovimiento: "2026-09-22",
      fecha: "2026-09-22",
      idContenedor: "-",
      no_tanque: "-",
      noLote: "nuev123",
      no_lote: "nuev123",
      noProduccion: "nuev123",
      categoria: "Mezcal Artesanal",
      clase: "Blanco Joven",
      materiaPrima: "-",
      tipoMaguey: "-",
      especie: "-",
      ingrediente: "",
      ingredientes: "",
      edad: "Sin edad",
      noAnalisis: "-",
      noAnalisisFisicoquimico: "-",
      clave_fq: "-",
      litros: 225,
      porcentaje_alc_vol: 48.5,
      invInicialVol: "225",
      invInicialAlc: "48.5",
      entradaProcedencia: "Destilación Lote nuev123",
      entradaVolumen: "225",
      entradaAlc: "48.5",
      entradaVolAgua: "0",
      salidaVolumen: "0",
      salidaAlc: "0",
      salidaDestino: "",
      invFinalVol: "225",
      invFinalAlc: "48.5",
      observaciones: "Ingreso a inventario de mezcal a granel.",
      inspector: "Ing. Carlos Mendoza (UI Autorizado)",
      status: "aprobado",
      statusUI: "aprobado"
    }
  ]);

  // Cómputo de registros efectivos de Granel combinando trazabilidad de Redux y registros locales
  const effectiveGranelRecords = useMemo(() => {
    const list = [];
    const seenLotes = new Set();

    (granelRecords || []).forEach(r => {
      list.push(r);
      if (r.id) seenLotes.add(r.id);
      if (r.noLote) seenLotes.add(r.noLote);
    });

    (reduxTrazabilidadLots || []).forEach(lot => {
      const loteName = lot.noProduccion || lot.granel?.noLote || lot.id;
      if (loteName && !seenLotes.has(loteName)) {
        const vol = lot.granel?.volFinal || lot.granel?.invFinalVol || lot.granel?.litros || lot.destilacion?.totalMezcalObtenido || 225;
        const alc = lot.granel?.alcFinal || lot.granel?.invFinalAlc || lot.granel?.porcentaje_alc_vol || lot.destilacion?.avgAlcMezcal || 48.5;
        const cat = lot.granel?.categoria || lot.categoria || "Mezcal Artesanal";
        const cls = lot.granel?.clase || lot.clase || "Blanco Joven";
        const esp = lot.granel?.tipoMaguey || lot.granel?.especie || lot.especies || lot.materiaPrima || "-";
        const fq = lot.granel?.noAnalisis || lot.granel?.noAnalisisFisicoquimico || lot.granel?.clave_fq || "-";
        const cont = lot.granel?.idContenedor || lot.granel?.no_tanque || "-";
        const fecha = lot.granel?.fechaMovimiento || lot.fechaActualizacion || lot.fechaInicio || new Date().toISOString().split('T')[0];

        list.push({
          id: `TRAZ-${loteName}`,
          noLote: loteName,
          no_lote: loteName,
          noProduccion: loteName,
          idContenedor: cont,
          no_tanque: cont,
          categoria: cat,
          clase: cls,
          tipoMaguey: esp,
          especie: esp,
          materiaPrima: esp,
          ingrediente: lot.granel?.ingrediente || "",
          ingredientes: lot.granel?.ingredientes || "",
          edad: "Sin edad",
          noAnalisis: fq,
          noAnalisisFisicoquimico: fq,
          clave_fq: fq,
          litros: parseFloat(vol) || 0,
          porcentaje_alc_vol: parseFloat(alc) || 0,
          invInicialVol: String(vol),
          invInicialAlc: String(alc),
          entradaProcedencia: `Destilación (Lote ${loteName})`,
          entradaVolumen: String(vol),
          entradaAlc: String(alc),
          salidaDestino: "",
          salidaVolumen: "0",
          salidaAlc: "0",
          invFinalVol: String(vol),
          invFinalAlc: String(alc),
          fechaMovimiento: fecha,
          fecha: fecha,
          observaciones: "Proveniente de Bitácora de Producción / Trazabilidad.",
          inspector: "Ing. Carlos Mendoza (UI Autorizado)",
          status: "aprobado",
          statusUI: "aprobado"
        });
        seenLotes.add(loteName);
      }
    });

    return list;
  }, [granelRecords, reduxTrazabilidadLots]);

  const [noTerminadoRecords, setNoTerminadoRecords] = useState([
    {
      id: "NT-ENV-01",
      fechaMovimiento: "2026-07-16",
      botCaja: "12 botellas",
      marca: "Don Julio Mezcal",
      noLoteGranel: "PROD-LOTE-01",
      loteEnvasado: "L-01-ENV-NT",
      categoria: "Mezcal Artesanal",
      clase: "Joven / Blanco",
      ingrediente: "Maguey Espadín",
      edad: "Sin edad",
      tipoMaguey: "Espadín",
      noAnalisis: "ANA-2026-098",
      capacidad: "750 ml",
      pctAlc: "48.5",
      invInicialCajas: "0",
      invInicialBotellas: "0",
      entradaProcedencia: "Línea de Envasado 1",
      entradaCajas: "50",
      entradaBotellas: "600",
      salidaCajas: "10",
      salidaBotellas: "120",
      salidaDestino: "Área de Etiquetado y Hologramas",
      invFinalCajas: "40",
      invFinalBotellas: "480",
      mermas: "2 botellas (rotura en línea)",
      observaciones: "Envasado inicial de lote sin etiquetar.",
      inspector: "Ing. Carlos Mendoza (16/07/2026)",
      status: "aprobado"
    }
  ]);

  const [terminadoRecords, setTerminadoRecords] = useState([
    {
      id: "T-ENV-01",
      fechaMovimiento: "2026-07-18",
      botCaja: "12 botellas",
      marca: "Don Julio Mezcal",
      noLoteGranel: "PROD-LOTE-01",
      loteEnvasado: "L-01-ENV-T",
      categoria: "Mezcal Artesanal",
      claseEtiqueta: "Joven / Blanco",
      ingredientesEtiqueta: "Maguey Espadín",
      edad: "Sin edad",
      tipoMagueyEtiqueta: "Espadín",
      noAnalisis: "ANA-2026-098",
      capacidad: "750 ml",
      pctAlcEtiqueta: "48.5",
      noInformeAprobacion: "INF-APR-ET-102",
      fechaAprobacionEtiqueta: "2026-07-17",
      invInicialCajas: "0",
      invInicialBotellas: "0",
      entradaProcedencia: "Etiquetado Lote NT-01",
      entradaCajas: "10",
      entradaBotellas: "120",
      salidaCajas: "5",
      salidaBotellas: "60",
      salidaDestino: "Almacén de Producto Terminado",
      invFinalCajas: "5",
      invFinalBotellas: "60",
      observaciones: "Ingreso inicial de botellas con holograma oficial.",
      inspector: "Ing. Carlos Mendoza (18/07/2026)",
      status: "aprobado"
    }
  ]);

  const [hologramaRecords, setHologramaRecords] = useState([
    {
      id: "HOL-01",
      idEnvasadoTerminado: "T-ENV-01",
      fechaMovimiento: "2026-07-18",
      marca: "Don Julio Mezcal",
      loteEnvasado: "L-01-ENV-T",
      capacidad: "750 ml",
      invInicialRango: "A0001 - A0500",
      invInicialCant: "500",
      entradaRango: "N/A",
      entradaCant: "0",
      salidaRango: "A0001 - A0120",
      salidaCant: "120",
      invFinalRango: "A0123 - A0500",
      invFinalCant: "378",
      mermasRango: "A0121 - A0122",
      mermasCant: "2",
      observaciones: "Aplicación inicial de hologramas para primer lote terminado.",
      inspector: "Ing. Carlos Mendoza (18/07/2026)",
      status: "aprobado"
    }
  ]);

  const [elaboracionRecords, setElaboracionRecords] = useState([
    {
      id: "ELAB-01",
      fechaIngreso: "2026-07-16",
      loteOrigen: "PROD-LOTE-01",
      volumenOrigen: "700",
      pctAlcOrigen: "48.5",
      categoriaOrigen: "Mezcal Artesanal",
      claseOrigen: "Joven / Blanco",
      ingredientesOrigen: "Maguey Espadín",
      edadOrigen: "Sin edad",
      analisisOrigen: "ANA-2026-098",
      tipoMagueyOrigen: "Espadín",
      ingredientesAdicionados: "Gusano de maguey",
      procesoRealizado: "ABOCADO CON",
      descripcionProceso: "Adición de gusano de maguey deshidratado a lote granel antes del envasado.",
      fechaSalida: "2026-07-17",
      loteSalida: "L-01-ENV-AB",
      volumenSalida: "695",
      pctAlcSalida: "48.2",
      claseSalida: "Abocado con Gusano",
      observaciones: "Filtración leve and adición manual de gusano.",
      inspector: "Ing. Carlos Mendoza (17/07/2026)",
      status: "aprobado"
    }
  ]);

  const [maduracionRecords, setMaduracionRecords] = useState([]);

  useEffect(() => {
    if (Array.isArray(reduxMaduracionRecords)) {
      setMaduracionRecords(reduxMaduracionRecords);
    }
  }, [reduxMaduracionRecords]);

  // Default pre-filled month for conditions
  const generateDefaultDailyData = () => {
    return Array.from({ length: 31 }).map((_, i) => ({
      dia: i + 1,
      hora: i < 5 ? "09:00" : "",
      temp: i < 5 ? (23 + (i % 3)).toString() : "",
      hum: i < 5 ? (60 - (i % 4)).toString() : ""
    }));
  };

  const [condionesRecords, setCondicionesRecords] = useState([
    {
      mesAnio: "Julio 2026",
      noLote: "PROD-LOTE-01",
      registros: generateDefaultDailyData(),
      observaciones: "Monitoreo correspondiente a los primeros días de maduración en bodega.",
      inspector: "Ing. Carlos Mendoza (19/07/2026)",
      status: "aprobado"
    }
  ]);

  const [quejasRecords, setQuejasRecords] = useState([
    {
      id: 1,
      fechaQueja: "2026-07-10",
      noQueja: "QJ-2026-001",
      noLote: "L-01-ENV-T",
      descripcionProducto: "Don Julio Mezcal - Mezcal Artesanal Joven / Blanco (750 ml)",
      detalleQueja: "El cliente reportó fuga leve de líquido en el tapón de corcho de 2 botellas.",
      fechaAtencion: "2026-07-12",
      medidasCorrectivas: "Se cambiaron los corchos del lote restante por un lote de mayor densidad y se re-inspeccionó el empaque.",
      inspector: "Ing. Carlos Mendoza (12/07/2026)",
      status: "aprobado"
    }
  ]);



  // ================= FORM STATES (SECCION II) =================
  const [fechaMovimiento, setFechaMovimiento] = useState("2026-07-19");
  const [idContenedor, setIdContenedor] = useState("C-10");
  const [noLote, setNoLote] = useState("PROD-LOTE-01");
  const [categoria, setCategoria] = useState("Mezcal Artesanal");
  const [clase, setClase] = useState("Joven / Blanco");
  const [ingrediente, setIngrediente] = useState("Maguey Espadín");
  const [edad, setEdad] = useState("Sin edad");
  const [tipoMaguey, setTipoMaguey] = useState("Espadín");
  const [noAnalisis, setNoAnalisis] = useState("ANA-2026-098");
  const [invInicialVol, setInvInicialVol] = useState("700");
  const [invInicialAlc, setInvInicialAlc] = useState("48.5");
  const [entradaProcedencia, setEntradaProcedencia] = useState("Destilación Lote 02");
  const [entradaVolumen, setEntradaVolumen] = useState("500");
  const [entradaAlc, setEntradaAlc] = useState("48.0");
  const [entradaVolAgua, setEntradaVolAgua] = useState("10");
  const [salidaVolumen, setSalidaVolumen] = useState("0");
  const [salidaAlc, setSalidaAlc] = useState("0.0");
  const [salidaDestino, setSalidaDestino] = useState("N/A");
  const [invFinalVol, setInvFinalVol] = useState("1210");
  const [invFinalAlc, setInvFinalAlc] = useState("47.8");
  const [observaciones, setObservaciones] = useState("");

  // ================= FORM STATES (SECCION III) =================
  const [ntFechaMovimiento, setNtFechaMovimiento] = useState("2026-07-19");
  const [ntBotCaja, setNtBotCaja] = useState("12 botellas");
  const [ntMarca, setNtMarca] = useState("Don Julio Mezcal");
  const [ntNoLoteGranel, setNtNoLoteGranel] = useState("PROD-LOTE-01");
  const [ntVolumenEnvasar, setNtVolumenEnvasar] = useState("750");
  const [ntNoInformeAprobacion, setNtNoInformeAprobacion] = useState("INF-APR-ET-102");
  const [ntLoteEnvasado, setNtLoteEnvasado] = useState("L-01-ENV-NT");
  const [ntCategoria, setNtCategoria] = useState("Mezcal Artesanal");
  const [ntClase, setNtClase] = useState("Joven / Blanco");
  const [ntIngrediente, setNtIngrediente] = useState("Maguey Espadín");
  const [ntEdad, setNtEdad] = useState("Sin edad");
  const [ntTipoMaguey, setNtTipoMaguey] = useState("Espadín");
  const [ntNoAnalisis, setNtNoAnalisis] = useState("ANA-2026-098");
  const [ntCapacidad, setNtCapacidad] = useState("750 ml");
  const [ntPctAlc, setNtPctAlc] = useState("48.5");
  const [ntInvInicialCajas, setNtInvInicialCajas] = useState("40");
  const [ntInvInicialBotellas, setNtInvInicialBotellas] = useState("480");
  const [ntEntradaProcedencia, setNtEntradaProcedencia] = useState("Línea de Envasado 1");
  const [ntEntradaCajas, setNtEntradaCajas] = useState("20");
  const [ntEntradaBotellas, setNtEntradaBotellas] = useState("240");
  const [ntSalidaCajas, setNtSalidaCajas] = useState("15");
  const [ntSalidaBotellas, setNtSalidaBotellas] = useState("180");
  const [ntSalidaDestino, setNtSalidaDestino] = useState("Área de Etiquetado y Hologramas");
  const [ntInvFinalCajas, setNtInvFinalCajas] = useState("45");
  const [ntInvFinalBotellas, setNtInvFinalBotellas] = useState("540");
  const [ntMermas, setNtMermas] = useState("0");
  const [ntObservaciones, setNtObservaciones] = useState("");

  // ================= FORM STATES (SECCION IV) =================
  const [tFechaMovimiento, setTFechaMovimiento] = useState("2026-07-19");
  const [tBotCaja, setTBotCaja] = useState("12 botellas");
  const [tMarca, setTMarca] = useState("Don Julio Mezcal");
  const [tNoLoteGranel, setTNoLoteGranel] = useState("PROD-LOTE-01");
  const [tLoteEnvasado, setTLoteEnvasado] = useState("L-01-ENV-T");
  const [tCategoria, setTCategoria] = useState("Mezcal Artesanal");
  const [tClaseEtiqueta, setTClaseEtiqueta] = useState("Joven / Blanco");
  const [tIngredientesEtiqueta, setTIngredientesEtiqueta] = useState("Maguey Espadín");
  const [tEdad, setTEdad] = useState("Sin edad");
  const [tTipoMagueyEtiqueta, setTTipoMagueyEtiqueta] = useState("Espadín");
  const [tNoAnalisis, setTNoAnalisis] = useState("ANA-2026-098");
  const [tCapacidad, setTCapacidad] = useState("750 ml");
  const [tPctAlcEtiqueta, setTPctAlcEtiqueta] = useState("48.5");
  const [tNoInformeAprobacion, setTNoInformeAprobacion] = useState("INF-APR-ET-102");
  const [tFechaAprobacionEtiqueta, setTFechaAprobacionEtiqueta] = useState("2026-07-17");
  const [tInvInicialCajas, setTInvInicialCajas] = useState("5");
  const [tInvInicialBotellas, setTInvInicialBotellas] = useState("60");
  const [tEntradaProcedencia, setTEntradaProcedencia] = useState("Etiquetado Lote NT-01");
  const [tEntradaCajas, setTEntradaCajas] = useState("15");
  const [tEntradaBotellas, setTEntradaBotellas] = useState("180");
  const [tSalidaCajas, setTSalidaCajas] = useState("10");
  const [tSalidaBotellas, setTSalidaBotellas] = useState("120");
  const [tSalidaDestino, setTSalidaDestino] = useState("Almacén de Producto Terminado");
  const [tInvFinalCajas, setTInvFinalCajas] = useState("10");
  const [tInvFinalBotellas, setTInvFinalBotellas] = useState("120");
  const [tObservaciones, setTObservaciones] = useState("");

  // ================= FORM STATES (SECCION V) =================
  const [hIdEnvasadoTerminado, setHIdEnvasadoTerminado] = useState("T-ENV-01");
  const [hFechaMovimiento, setHFechaMovimiento] = useState("2026-07-19");
  const [hMarca, setHMarca] = useState("Don Julio Mezcal");
  const [hLoteEnvasado, setHLoteEnvasado] = useState("L-01-ENV-T");
  const [hCapacidad, setHCapacidad] = useState("750 ml");
  const [hInvInicialRango, setHInvInicialRango] = useState("A0123 - A0500");
  const [hInvInicialCant, setHInvInicialCant] = useState("378");
  const [hEntradaRango, setHEntradaRango] = useState("B0001 - B0500");
  const [hEntradaCant, setHEntradaCant] = useState("500");
  const [hSalidaRango, setHSalidaRango] = useState("A0123 - A0223");
  const [hSalidaCant, setHSalidaCant] = useState("101");
  const [hInvFinalRango, setHInvFinalRango] = useState("A0224 - A0500, B0001 - B0500");
  const [hInvFinalCant, setHInvFinalCant] = useState("777");
  const [hMermasRango, setHMermasRango] = useState("N/A");
  const [hMermasCant, setHMermasCant] = useState("0");
  const [hObservaciones, setHObservaciones] = useState("");

  // ================= FORM STATES (SECCION VI) =================
  const [elabFechaIngreso, setElabFechaIngreso] = useState("2026-07-19");
  const [elabLoteOrigen, setElabLoteOrigen] = useState("PROD-LOTE-01");
  const [elabVolumenOrigen, setElabVolumenOrigen] = useState("700");
  const [elabPctAlcOrigen, setElabPctAlcOrigen] = useState("48.5");
  const [elabCategoriaOrigen, setElabCategoriaOrigen] = useState("Mezcal Artesanal");
  const [elabClaseOrigen, setElabClaseOrigen] = useState("Joven / Blanco");
  const [elabIngredientesOrigen, setElabIngredientesOrigen] = useState("Maguey Espadín");
  const [elabEdadOrigen, setElabEdadOrigen] = useState("Sin edad");
  const [elabAnalisisOrigen, setElabAnalisisOrigen] = useState("ANA-2026-098");
  const [elabTipoMagueyOrigen, setElabTipoMagueyOrigen] = useState("Espadín");
  const [elabIngredientesAdicionados, setElabIngredientesAdicionados] = useState("Gusano de maguey");
  const [elabProcesoRealizado, setElabProcesoRealizado] = useState("ABOCADO CON");
  const [elabDescripcionProceso, setElabDescripcionProceso] = useState("Proceso de abocado con gusano.");
  const [elabFechaSalida, setElabFechaSalida] = useState("2026-07-19");
  const [elabLoteSalida, setElabLoteSalida] = useState("L-01-ENV-AB");
  const [elabVolumenSalida, setElabVolumenSalida] = useState("695");
  const [elabPctAlcSalida, setElabPctAlcSalida] = useState("48.2");
  const [elabClaseSalida, setElabClaseSalida] = useState("ABOCADO CON");
  const [elabObservaciones, setElabObservaciones] = useState("");

  // ================= FORM STATES (SECCION VII) =================
  const [madFechaMovimiento, setMadFechaMovimiento] = useState("2026-07-19");
  const [madNoLote, setMadNoLote] = useState("PROD-LOTE-01");
  const [madCategoria, setMadCategoria] = useState("Mezcal Artesanal");
  const [madClase, setMadClase] = useState("Joven / Blanco");
  const [madIngredientes, setMadIngredientes] = useState("Maguey Espadín");
  const [madEdad, setMadEdad] = useState("Sin edad");
  const [madTipoMaguey, setMadTipoMaguey] = useState("Espadín");
  const [madNoAnalisis, setMadNoAnalisis] = useState("ANA-2026-098");
  const [madTipoRecipiente, setMadTipoRecipiente] = useState("BARRICAS DE MADERA DE");
  const [madDetalleRecipiente, setMadDetalleRecipiente] = useState("Roble Blanco Americano");
  const [madInvInicialFecha, setMadInvInicialFecha] = useState("2026-07-19");
  const [madInvInicialRecipientes, setMadInvInicialRecipientes] = useState("2");
  const [madInvInicialVolumen, setMadInvInicialVolumen] = useState("400");
  const [madInvInicialAlc, setMadInvInicialAlc] = useState("48.5");
  const [madEntradaFolio, setMadEntradaFolio] = useState("");
  const [madEntradaRecipientes, setMadEntradaRecipientes] = useState("0");
  const [madEntradaVolumen, setMadEntradaVolumen] = useState("0");
  const [madEntradaAlc, setMadEntradaAlc] = useState("0.0");
  const [madSalidaRecipientes, setMadSalidaRecipientes] = useState("1");
  const [madSalidaVolumen, setMadSalidaVolumen] = useState("200");
  const [madSalidaAlc, setMadSalidaAlc] = useState("48.0");
  const [madSalidaClaseObtenida, setMadSalidaClaseObtenida] = useState("Reposado");
  const [madSalidaEdadObtenida, setMadSalidaEdadObtenida] = useState("3 meses");
  const [madSalidaMerma, setMadSalidaMerma] = useState("5");
  const [madInvFinalRecipientes, setMadInvFinalRecipientes] = useState("1");
  const [madInvFinalVolumen, setMadInvFinalVolumen] = useState("195");
  const [madInvFinalAlc, setMadInvFinalAlc] = useState("48.0");
  const [madObservaciones, setMadObservaciones] = useState("");

  // ================= FORM STATES (SECCION VIII) =================
  const [condMesAnio, setCondMesAnio] = useState("Julio 2026");
  const [condNoLote, setCondNoLote] = useState("PROD-LOTE-01");
  const [condDailyData, setCondDailyData] = useState(generateDefaultDailyData());
  const [condObservaciones, setCondObservaciones] = useState("");

  // ================= FORM STATES (SECCION IX) =================
  const [fechaQueja, setFechaQueja] = useState("2026-07-19");
  const [noQueja, setNoQueja] = useState("");
  const [quejaNoLote, setQuejaNoLote] = useState("manual");
  const [descripcionProducto, setDescripcionProducto] = useState("");
  const [detalleQueja, setDetalleQueja] = useState("");
  const [fechaAtencion, setFechaAtencion] = useState("");
  const [medidasCorrectivas, setMedidasCorrectivas] = useState("");
  const [editingGranelId, setEditingGranelId] = useState(null);
  const [granelFormData, setGranelFormData] = useState({
    fechaMovimiento: new Date().toISOString().split("T")[0],
    idContenedor: "",
    noLote: "",
    clave_fq: "",
    especie: "",
    categoria: "Mezcal Artesanal",
    clase: "Blanco Joven",
    ingrediente: "",
    litros: "",
    porcentaje_alc_vol: ""
  });

  const handleOpenNewGranelRecord = () => {
    setEditingGranelId(null);
    setGranelFormData({
      id: null,
      fechaMovimiento: new Date().toISOString().split("T")[0],
      fecha: new Date().toISOString().split("T")[0],
      idContenedor: "",
      no_tanque: "",
      noLote: "",
      no_lote: "",
      categoria: "Mezcal Artesanal",
      clase: "Blanco Joven",
      especie: "",
      tipoMaguey: "",
      ingrediente: "",
      ingredientes: "",
      clave_fq: "",
      noAnalisis: "",
      litros: "",
      porcentaje_alc_vol: "",
      invInicialVol: "0",
      invInicialAlc: "0",
      entradaProcedencia: "Destilación",
      entradaVolumen: "0",
      entradaAlc: "0",
      salidaDestino: "",
      salidaVolumen: "0",
      salidaAlc: "0",
      invFinalVol: "0",
      invFinalAlc: "0",
      observaciones: "Ingreso a inventario de mezcal a granel.",
      status: "borrador"
    });
    setIsFormOpen(true);
  };

  const handleSaveFusion = (newGranelData, validSources) => {
    setGranelRecords(prev => [newGranelData, ...prev]);
  };

  const handleSaveGranel = (statusOrEvent, customStatus = "aprobado", optionalData = null) => {
    if (statusOrEvent && statusOrEvent.preventDefault) statusOrEvent.preventDefault();
    const activeData = optionalData || (typeof customStatus === "object" ? customStatus : null) || granelFormData || {};

    const targetLote = activeData.noLote || activeData.no_lote || `GRANEL-ENV-${Date.now().toString().slice(-4)}`;
    const finalStatus = typeof customStatus === "string" ? customStatus : (activeData.status || "aprobado");
    const isBorrador = finalStatus === "borrador";
    const statusUI = isBorrador ? "borrador" : "aprobado";

    const volMezcal = String(activeData.litros || activeData.invFinalVol || activeData.entradaVolumen || "0").replace(/[^\d.]/g, "");
    const alcMezcal = String(activeData.porcentaje_alc_vol || activeData.invFinalAlc || activeData.entradaAlc || "0").replace(/[^\d.]/g, "");

    const recordToSave = {
      id: activeData.id || `GRA-ENV-${Date.now().toString().slice(-4)}`,
      noLote: targetLote,
      no_lote: targetLote,
      noProduccion: targetLote,
      idContenedor: activeData.idContenedor || activeData.no_tanque || "-",
      no_tanque: activeData.no_tanque || activeData.idContenedor || "-",
      categoria: activeData.categoria || "Mezcal Artesanal",
      clase: activeData.clase || "Blanco Joven",
      fechaMovimiento: activeData.fechaMovimiento || activeData.fecha || new Date().toISOString().split("T")[0],
      fecha: activeData.fecha || activeData.fechaMovimiento || new Date().toISOString().split("T")[0],
      noAnalisisFisicoquimico: activeData.clave_fq || activeData.noAnalisis || "-",
      noAnalisis: activeData.clave_fq || activeData.noAnalisis || "-",
      clave_fq: activeData.clave_fq || activeData.noAnalisis || "-",
      tipoMaguey: activeData.especie || activeData.tipoMaguey || "-",
      especie: activeData.especie || activeData.tipoMaguey || "-",
      materiaPrima: activeData.especie || activeData.tipoMaguey || "-",
      ingredientes: activeData.ingredientes || activeData.ingrediente || "",
      ingrediente: activeData.ingrediente || activeData.ingredientes || "",
      edad: "Sin edad",
      litros: parseFloat(volMezcal) || 0,
      porcentaje_alc_vol: parseFloat(alcMezcal) || 0,
      invInicialVol: volMezcal,
      invInicialAlc: alcMezcal,
      entradaProcedencia: activeData.entradaProcedencia || `Destilación (Lote ${targetLote})`,
      entradaVolumen: volMezcal,
      entradaAlc: alcMezcal,
      salidaDestino: activeData.salidaDestino || "",
      salidaVolumen: String(activeData.salidaVolumen || "0").replace(/[^\d.]/g, ""),
      salidaAlc: String(activeData.salidaAlc || "0").replace(/[^\d.]/g, ""),
      invFinalVol: volMezcal,
      invFinalAlc: alcMezcal,
      observaciones: activeData.observaciones || "Movimiento registrado en Bitácora de Envasado.",
      inspector: "Ing. Carlos Mendoza (UI Autorizado)",
      status: finalStatus,
      statusUI: statusUI
    };

    setGranelRecords(prev => {
      const exists = prev.some(r => r.id === recordToSave.id);
      if (exists) {
        return prev.map(r => r.id === recordToSave.id ? { ...r, ...recordToSave } : r);
      }
      return [recordToSave, ...prev];
    });

    setIsFormOpen(false);
    Swal.fire({
      icon: "success",
      title: isBorrador ? "Borrador Guardado" : "¡Registro Guardado!",
      text: isBorrador ? "El borrador de granel ha sido guardado exitosamente." : "El movimiento a granel fue guardado correctamente.",
      timer: 2000,
      showConfirmButton: false
    });
  };

  const handleEditGranelRecord = (rec) => {
    if (rec) {
      setEditingGranelId(rec.id);
      const vol = String(rec.litros ?? rec.invFinalVol ?? rec.entradaVolumen ?? "0").replace(/[^\d.]/g, "");
      const alc = String(rec.porcentaje_alc_vol ?? rec.invFinalAlc ?? rec.entradaAlc ?? "0").replace(/[^\d.]/g, "");
      setGranelFormData({
        id: rec.id,
        fechaMovimiento: rec.fechaMovimiento || rec.fecha || new Date().toISOString().split("T")[0],
        fecha: rec.fecha || rec.fechaMovimiento || new Date().toISOString().split("T")[0],
        idContenedor: rec.idContenedor || rec.no_tanque || "",
        no_tanque: rec.no_tanque || rec.idContenedor || "",
        noLote: rec.noLote || rec.no_lote || rec.noProduccion || "",
        no_lote: rec.no_lote || rec.noLote || rec.noProduccion || "",
        categoria: rec.categoria || "Mezcal Artesanal",
        clase: rec.clase || "Blanco Joven",
        ingredientes: rec.ingredientes || rec.ingrediente || "",
        ingrediente: rec.ingrediente || rec.ingredientes || "",
        tipoMaguey: rec.tipoMaguey || rec.especie || "",
        especie: rec.especie || rec.tipoMaguey || "",
        noAnalisis: rec.noAnalisisFisicoquimico || rec.noAnalisis || rec.clave_fq || "",
        clave_fq: rec.clave_fq || rec.noAnalisisFisicoquimico || rec.noAnalisis || "",
        litros: vol,
        porcentaje_alc_vol: alc,
        invInicialVol: String(rec.invInicialVol || vol).replace(/[^\d.]/g, ""),
        invInicialAlc: String(rec.invInicialAlc || alc).replace(/[^\d.]/g, ""),
        entradaProcedencia: rec.entradaProcedencia || "",
        entradaVolumen: vol,
        entradaAlc: alc,
        salidaDestino: rec.salidaDestino || "",
        salidaVolumen: String(rec.salidaVolumen || "0").replace(/[^\d.]/g, ""),
        salidaAlc: String(rec.salidaAlc || "0").replace(/[^\d.]/g, ""),
        invFinalVol: vol,
        invFinalAlc: alc,
        observaciones: rec.observaciones || "",
        status: rec.status || "borrador"
      });
      setIsFormOpen(true);
    }
  };

  const handleSaveNoTerminado = (status) => {
    const newRecord = {
      id: `NT-ENV-0${noTerminadoRecords.length + 1}`,
      fechaMovimiento: ntFechaMovimiento,
      botCaja: ntBotCaja,
      marca: ntMarca,
      noLoteGranel: ntNoLoteGranel,
      volumenEnvasar: ntVolumenEnvasar,
      noInformeAprobacion: ntNoInformeAprobacion,
      loteEnvasado: ntLoteEnvasado,
      categoria: ntCategoria,
      clase: ntClase,
      ingrediente: ntIngrediente,
      edad: ntEdad,
      tipoMaguey: ntTipoMaguey,
      noAnalisis: ntNoAnalisis,
      capacidad: ntCapacidad,
      pctAlc: ntPctAlc,
      invInicialCajas: ntInvInicialCajas,
      invInicialBotellas: ntInvInicialBotellas,
      entradaProcedencia: ntEntradaProcedencia,
      entradaCajas: ntEntradaCajas,
      entradaBotellas: ntEntradaBotellas,
      salidaCajas: ntSalidaCajas,
      salidaBotellas: ntSalidaBotellas,
      salidaDestino: ntSalidaDestino,
      invFinalCajas: ntInvFinalCajas,
      invFinalBotellas: ntInvFinalBotellas,
      mermas: ntMermas || "0",
      observaciones: ntObservaciones || "Sin observaciones.",
      inspector: "Pendiente de V.Bo.",
      status: status
    };
    setNoTerminadoRecords([...noTerminadoRecords, newRecord]);
    setIsFormOpen(false);
    alert(status === "revision" ? "¡Movimiento de Envasado No Terminado registrado!" : "Borrador guardado.");
  };

  const handleRegistrarEnvasadoFromGranel = (rec) => {
    const loteVal = rec.noLote || rec.no_lote || rec.noProduccion || rec.id;
    setNtNoLoteGranel(loteVal);
    if (rec.categoria) setNtCategoria(rec.categoria);
    if (rec.clase) setNtClase(rec.clase);
    const maguey = rec.tipoMaguey || rec.especie || rec.materiaPrima || rec.tipo_maguey || "";
    if (maguey) setNtTipoMaguey(maguey);
    const fq = rec.noAnalisisFisicoquimico || rec.noAnalisis || rec.clave_fq || "";
    if (fq && fq !== "-") setNtNoAnalisis(fq);
    const alc = rec.porcentaje_alc_vol || rec.invFinalAlc || rec.alcFinal || "";
    if (alc) setNtPctAlc(String(alc));
    const ing = rec.ingrediente || rec.ingredientes || (maguey ? `100% ${maguey}` : "");
    if (ing) setNtIngrediente(ing);
    if (rec.edad) setNtEdad(rec.edad);
    const vol = rec.litros || rec.invFinalVol || rec.volFinal || "";
    if (vol) setNtVolumenEnvasar(String(vol));

    setActiveTab(1);
    setIsFormOpen(true);
  };

  const handleSaveTerminado = (status) => {
    const newRecord = {
      id: `T-ENV-0${terminadoRecords.length + 1}`,
      fechaMovimiento: tFechaMovimiento,
      botCaja: tBotCaja,
      marca: tMarca,
      noLoteGranel: tNoLoteGranel,
      loteEnvasado: tLoteEnvasado,
      categoria: tCategoria,
      claseEtiqueta: tClaseEtiqueta,
      ingredientesEtiqueta: tIngredientesEtiqueta,
      edad: tEdad,
      tipoMagueyEtiqueta: tTipoMagueyEtiqueta,
      noAnalisis: tNoAnalisis,
      capacidad: tCapacidad,
      pctAlcEtiqueta: tPctAlcEtiqueta,
      noInformeAprobacion: tNoInformeAprobacion,
      fechaAprobacionEtiqueta: tFechaAprobacionEtiqueta,
      invInicialCajas: tInvInicialCajas,
      invInicialBotellas: tInvInicialBotellas,
      entradaProcedencia: tEntradaProcedencia,
      entradaCajas: tEntradaCajas,
      entradaBotellas: tEntradaBotellas,
      salidaCajas: tSalidaCajas,
      salidaBotellas: tSalidaBotellas,
      salidaDestino: tSalidaDestino,
      invFinalCajas: tInvFinalCajas,
      invFinalBotellas: tInvFinalBotellas,
      observaciones: tObservaciones || "Sin observaciones.",
      inspector: "Pendiente de V.Bo.",
      status: status
    };
    setTerminadoRecords([...terminadoRecords, newRecord]);
    setIsFormOpen(false);
    alert(status === "revision" ? "¡Movimiento de Envasado Terminado registrado exitosamente!" : "Borrador guardado.");
  };

  const handleSaveHologramas = (status) => {
    const newRecord = {
      id: `HOL-0${hologramaRecords.length + 1}`,
      idEnvasadoTerminado: hIdEnvasadoTerminado,
      fechaMovimiento: hFechaMovimiento,
      marca: hMarca,
      loteEnvasado: hLoteEnvasado,
      capacidad: hCapacidad,
      invInicialRango: hInvInicialRango,
      invInicialCant: hInvInicialCant,
      entradaRango: hEntradaRango,
      entradaCant: hEntradaCant,
      salidaRango: hSalidaRango,
      salidaCant: hSalidaCant,
      invFinalRango: hInvFinalRango,
      invFinalCant: hInvFinalCant,
      mermasRango: hMermasRango,
      mermasCant: hMermasCant,
      observaciones: hObservaciones || "Sin observaciones.",
      inspector: "Pendiente de V.Bo.",
      status: status
    };
    setHologramaRecords([...hologramaRecords, newRecord]);
    setIsFormOpen(false);
    alert(status === "revision" ? "¡Inventario de Hologramas registrado exitosamente!" : "Borrador guardado.");
  };

  const handleCompleteEnvasadoFromNoTerminado = (sourceRec, finishedData) => {
    const newTerminado = {
      id: `T-ENV-0${terminadoRecords.length + 1}`,
      idNoTerminadoOrigen: sourceRec.id,
      fechaMovimiento: sourceRec.fechaMovimiento || finishedData.fechaAprobacionEtiqueta || new Date().toISOString().split("T")[0],
      botCaja: sourceRec.botCaja || "12 botellas",
      marca: sourceRec.marca,
      noLoteGranel: sourceRec.noLoteGranel,
      loteEnvasado: sourceRec.loteEnvasado,
      categoria: sourceRec.categoria,
      claseEtiqueta: finishedData.claseEtiqueta || sourceRec.clase || "Joven / Blanco",
      ingredientesEtiqueta: finishedData.ingredientesEtiqueta || sourceRec.ingrediente || "",
      edad: sourceRec.edad || "Sin edad",
      tipoMagueyEtiqueta: finishedData.tipoMagueyEtiqueta || sourceRec.tipoMaguey || "Espadín",
      noAnalisis: sourceRec.noAnalisis,
      capacidad: sourceRec.capacidad || "750 ml",
      pctAlcEtiqueta: finishedData.pctAlcEtiqueta || sourceRec.pctAlc || "48.5",
      noInformeAprobacion: finishedData.noInformeAprobacion,
      fechaAprobacionEtiqueta: finishedData.fechaAprobacionEtiqueta,
      invInicialCajas: finishedData.invInicialCajas || "0",
      invInicialBotellas: finishedData.invInicialBotellas || "0",
      entradaProcedencia: finishedData.entradaProcedencia || `Etiquetado de lote ${sourceRec.loteEnvasado}`,
      entradaCajas: finishedData.entradaCajas || "0",
      entradaBotellas: finishedData.entradaBotellas || "0",
      salidaCajas: finishedData.salidaCajas || "0",
      salidaBotellas: finishedData.salidaBotellas || "0",
      salidaDestino: finishedData.salidaDestino || "Almacén de Producto Terminado",
      invFinalCajas: finishedData.invFinalCajas || "0",
      invFinalBotellas: finishedData.invFinalBotellas || "0",
      observaciones: finishedData.observaciones || "Envasado Terminado (Sección IV)",
      inspector: "Pendiente de V.Bo.",
      status: "revision",
      estadoProceso: "terminado"
    };

    setTerminadoRecords(prev => [...prev, newTerminado]);

    setNoTerminadoRecords(prev =>
      prev.map(item =>
        item.id === sourceRec.id ? { ...item, estadoProceso: "terminado" } : item
      )
    );
  };

  const handleSaveHologramasFromNoTerminado = (sourceRec, hologramData) => {
    const newHologramas = {
      id: `HOL-0${hologramaRecords.length + 1}`,
      idEnvasadoTerminado: sourceRec.id,
      fechaMovimiento: sourceRec.fechaMovimiento || new Date().toISOString().split("T")[0],
      marca: sourceRec.marca,
      loteEnvasado: sourceRec.loteEnvasado,
      capacidad: sourceRec.capacidad || "750 ml",
      invInicialRango: hologramData.invInicialRango,
      invInicialCant: hologramData.invInicialCant,
      entradaRango: hologramData.entradaRango,
      entradaCant: hologramData.entradaCant,
      salidaRango: hologramData.salidaRango,
      salidaCant: hologramData.salidaCant,
      invFinalRango: hologramData.invFinalRango,
      invFinalCant: hologramData.invFinalCant,
      mermasRango: hologramData.mermasRango,
      mermasCant: hologramData.mermasCant,
      observaciones: hologramData.observaciones || "Control de Hologramas (Sección V)",
      inspector: "Pendiente de V.Bo.",
      status: "revision"
    };

    setHologramaRecords(prev => [...prev, newHologramas]);

    setNoTerminadoRecords(prev =>
      prev.map(item =>
        item.id === sourceRec.id ? { ...item, estadoProceso: "hologramado" } : item
      )
    );

    setTerminadoRecords(prev =>
      prev.map(item =>
        item.loteEnvasado === sourceRec.loteEnvasado ? { ...item, estadoProceso: "hologramado" } : item
      )
    );
  };


  const handleSaveElaboracion = (status) => {
      const getClase = (proc) => {
        const p = String(proc || '').toUpperCase().trim();
        if (p.includes('ABOCADO')) return 'ABOCADO CON';
        if (p.includes('DESTILADO')) return 'DESTILADO CON';
        if (p.includes('REPROCESO') || p.includes('REACONDICIONAMIENTO')) return 'BLANCO O JOVEN';
        return 'BLANCO O JOVEN';
      };
      const finalClase = getClase(elabProcesoRealizado);

      const newRecord = {
        id: `ELAB-0${elaboracionRecords.length + 1}`,
        fechaIngreso: elabFechaIngreso,
        loteOrigen: elabLoteOrigen,
        volumenOrigen: elabVolumenOrigen,
        pctAlcOrigen: elabPctAlcOrigen,
        categoriaOrigen: elabCategoriaOrigen,
        claseOrigen: elabClaseOrigen,
        ingredientesOrigen: elabIngredientesOrigen,
        edadOrigen: elabEdadOrigen,
        analisisOrigen: elabAnalisisOrigen,
        tipoMagueyOrigen: elabTipoMagueyOrigen,
        ingredientesAdicionados: elabIngredientesAdicionados,
        procesoRealizado: elabProcesoRealizado,
        descripcionProceso: elabDescripcionProceso,
        fechaSalida: elabFechaSalida,
        loteSalida: elabLoteSalida,
        volumenSalida: elabVolumenSalida,
        pctAlcSalida: elabPctAlcSalida,
        claseSalida: finalClase,
        observaciones: elabObservaciones || "Sin observaciones.",
        inspector: "Pendiente de V.Bo.",
        status: status
      };
    setElaboracionRecords([...elaboracionRecords, newRecord]);
    setIsFormOpen(false);
    alert(status === "revision" ? "¡Elaboración de Clase registrada exitosamente!" : "Borrador guardado.");
  };

  const handleSaveMaduracion = async (status) => {
    try {
      const payload = {
        id_login: idLogin,
        fechaMovimiento: madFechaMovimiento,
        fecha_inicio_maduracion: madFechaMovimiento,
        noLote: madNoLote,
        lote_maduracion: madNoLote,
        categoria: madCategoria,
        clase: madClase,
        ingredientes: madIngredientes,
        edad: madEdad,
        tipoMaguey: madTipoMaguey,
        tipo_maguey: madTipoMaguey,
        noAnalisis: madNoAnalisis,
        no_analisis: madNoAnalisis,
        recipientes: [{
          tipo_recipiente: madTipoRecipiente,
          tipoRecipiente: madTipoRecipiente,
          detalle_recipiente: madDetalleRecipiente,
          detalleRecipiente: madDetalleRecipiente,
          inv_inicial_fecha: madInvInicialFecha,
          invInicialFecha: madInvInicialFecha,
          inv_inicial_recipientes: parseInt(madInvInicialRecipientes || 1, 10),
          invInicialRecipientes: parseInt(madInvInicialRecipientes || 1, 10),
          inv_inicial_volumen: parseFloat(madInvInicialVolumen || 0),
          invInicialVolumen: parseFloat(madInvInicialVolumen || 0),
          inv_inicial_alc: parseFloat(madInvInicialAlc || 0),
          invInicialAlc: parseFloat(madInvInicialAlc || 0),
          entrada_folio: madEntradaFolio || "",
          entradaFolio: madEntradaFolio || "",
          entrada_recipientes: parseInt(madEntradaRecipientes || 0, 10),
          entradaRecipientes: parseInt(madEntradaRecipientes || 0, 10),
          entrada_volumen: parseFloat(madEntradaVolumen || 0),
          entradaVolumen: parseFloat(madEntradaVolumen || 0),
          entrada_alc: parseFloat(madEntradaAlc || 0),
          entradaAlc: parseFloat(madEntradaAlc || 0),
          salida_recipientes: parseInt(madSalidaRecipientes || 0, 10),
          salidaRecipientes: parseInt(madSalidaRecipientes || 0, 10),
          salida_volumen: parseFloat(madSalidaVolumen || 0),
          salidaVolumen: parseFloat(madSalidaVolumen || 0),
          salida_alc: parseFloat(madSalidaAlc || 0),
          salidaAlc: parseFloat(madSalidaAlc || 0),
          clase_obtenida: madSalidaClaseObtenida || null,
          claseObtenida: madSalidaClaseObtenida || null,
          edad_obtenida: madSalidaEdadObtenida || null,
          edadObtenida: madSalidaEdadObtenida || null,
          salida_merma: parseFloat(madSalidaMerma || 0),
          salidaMerma: parseFloat(madSalidaMerma || 0),
          inv_final_recipientes: parseInt(madInvFinalRecipientes || 1, 10),
          invFinalRecipientes: parseInt(madInvFinalRecipientes || 1, 10),
          inv_final_volumen: parseFloat(madInvFinalVolumen || 0),
          invFinalVolumen: parseFloat(madInvFinalVolumen || 0),
          inv_final_alc: parseFloat(madInvFinalAlc || 0),
          invFinalAlc: parseFloat(madInvFinalAlc || 0)
        }],
        observaciones: madObservaciones || "Sin observaciones.",
        estatus: status === "revision" ? "enviada" : "borrador"
      };

      const resAction = await dispatch(registrarMaduracionAsociado(payload));
      if (resAction?.error) {
        Swal.fire("Error", resAction.payload || "No se pudo guardar el registro de maduración", "error");
        return;
      }

      setIsFormOpen(false);
      Swal.fire({
        title: "¡Éxito!",
        text: status === "revision" ? "¡Registro de Maduración enviado a revisión!" : "Borrador de Maduración guardado.",
        icon: "success",
        confirmButtonColor: "#4A5D23"
      });

      if (idLogin) {
        dispatch(obtenerMaduracionPorLogin(idLogin));
      }
    } catch (err) {
      console.error("Error al guardar maduración:", err);
      Swal.fire("Error", "Ocurrió un error inesperado al guardar la maduración", "error");
    }
  };

  const handleSaveCondiciones = (status) => {
    const newRecord = {
      mesAnio: condMesAnio,
      noLote: condNoLote,
      registros: [...condDailyData],
      observaciones: condObservaciones || "Sin observaciones.",
      inspector: "Pendiente de V.Bo.",
      status: status
    };
    setCondicionesRecords([...condionesRecords, newRecord]);
    setIsFormOpen(false);
    setCondDailyData(generateDefaultDailyData());
    alert(status === "revision" ? "¡Registro mensual de condiciones guardado exitosamente!" : "Borrador guardado.");
  };

  const handleSaveQueja = (status) => {
    const newRecord = {
      id: quejasRecords.length + 1,
      fechaQueja,
      noQueja,
      noLote: quejaNoLote,
      descripcionProducto,
      detalleQueja,
      fechaAtencion,
      medidasCorrectivas,
      inspector: "Pendiente de V.Bo.",
      status: status
    };
    setQuejasRecords([...quejasRecords, newRecord]);
    setIsFormOpen(false);
    setNoQueja("");
    setDetalleQueja("");
    setMedidasCorrectivas("");
    alert(status === "revision" ? "¡Queja registrada exitosamente!" : "Borrador guardado.");
  };

  return (
    <div className="container2">
      {/* Decorative Blurs */}
      <div className="glow-blob glow-1"></div>
      <div className="glow-blob glow-2"></div>

      {/* HEADER */}
      <header className="main-trace-header">
        <div className="header-branding">
          <div className="header-icon-box" style={{ background: "linear-gradient(135deg, #10B981 0%, #059669 100%)", boxShadow: "0 8px 18px rgba(16, 185, 129, 0.25)" }}>
            <LocalBarIcon style={{ fontSize: 30 }} />
          </div>
          <div>
            <div className="header-tag">COMERCAM • TRAZABILIDAD COMERCIAL</div>
            <h1>Bitácora de Envasado de Mezcal</h1>
            <p>Control integral de inventarios a granel, producto no terminado, terminado y control de hologramas</p>
          </div>
        </div>

        <div className="header-controls-envasado">
          <span className={`status-badge-envasado ${tabsInfo[activeTab]?.theme || 'status-cierre'}`}>
            {tabsInfo[activeTab]?.title} • {tabsInfo[activeTab]?.name}
          </span>
        </div>
      </header>

      {/* SECTIONS TABS (SEGMENTED PILLS) */}
      <div className="tabs-nav-bar-container">
        <div className="segmented-pill-container">
          {tabsInfo.map((tab) => {
            const IconComponent = tab.icon;
            const isActive = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                type="button"
                className={`segmented-pill-btn ${isActive ? "active" : ""}`}
                onClick={() => {
                  setActiveTab(tab.id);
                  setIsFormOpen(false);
                }}
              >
                <IconComponent style={{ fontSize: 16 }} />
                <span>{tab.shortLabel}</span>
              </button>
            );
          })}
        </div>
      </div>

      {/* ACTIVE SECTION CONTENT */}
      <main className="section-tab-container animate-fadeIn">

        {/* SECCIÓN II: GRANEL */}
        {activeTab === 0 && (
          <InventarioGranelSection
            granelRecords={effectiveGranelRecords}
            catalogoMaguey={reduxCatalogoMaguey}
            isFormOpen={isFormOpen}
            setIsFormOpen={setIsFormOpen}
            formData={granelFormData}
            setFormData={setGranelFormData}
            handleSaveGranel={handleSaveGranel}
            handleEditRecord={handleEditGranelRecord}
            handleOpenNewRecord={handleOpenNewGranelRecord}
            handleSaveFusion={handleSaveFusion}
            onRegistrarEnvasado={handleRegistrarEnvasadoFromGranel}
          />
        )}

        {/* SECCIÓN III: ENVASADO NO TERMINADO */}
        {activeTab === 1 && (
          <EnvasadoNoTerminadoSection
            noTerminadoRecords={noTerminadoRecords}
            granelRecords={effectiveGranelRecords}
            isFormOpen={isFormOpen}
            setIsFormOpen={setIsFormOpen}
            fechaMovimiento={ntFechaMovimiento}
            setFechaMovimiento={setNtFechaMovimiento}
            botCaja={ntBotCaja}
            setBotCaja={setNtBotCaja}
            marca={ntMarca}
            setMarca={setNtMarca}
            noLoteGranel={ntNoLoteGranel}
            setNoLoteGranel={setNtNoLoteGranel}
            volumenEnvasar={ntVolumenEnvasar}
            setVolumenEnvasar={setNtVolumenEnvasar}
            noInformeAprobacion={ntNoInformeAprobacion}
            setNoInformeAprobacion={setNtNoInformeAprobacion}
            loteEnvasado={ntLoteEnvasado}
            setLoteEnvasado={setNtLoteEnvasado}
            categoria={ntCategoria}
            setCategoria={setNtCategoria}
            clase={ntClase}
            setClase={setNtClase}
            ingrediente={ntIngrediente}
            setIngrediente={setNtIngrediente}
            edad={ntEdad}
            setEdad={setNtEdad}
            tipoMaguey={ntTipoMaguey}
            setTipoMaguey={setNtTipoMaguey}
            noAnalisis={ntNoAnalisis}
            setNoAnalisis={setNtNoAnalisis}
            capacidad={ntCapacidad}
            setCapacidad={setNtCapacidad}
            pctAlc={ntPctAlc}
            setPctAlc={setNtPctAlc}
            invInicialCajas={ntInvInicialCajas}
            setInvInicialCajas={setNtInvInicialCajas}
            invInicialBotellas={ntInvInicialBotellas}
            setInvInicialBotellas={setNtInvInicialBotellas}
            entradaProcedencia={ntEntradaProcedencia}
            setEntradaProcedencia={setNtEntradaProcedencia}
            entradaCajas={ntEntradaCajas}
            setEntradaCajas={setNtEntradaCajas}
            entradaBotellas={ntEntradaBotellas}
            setEntradaBotellas={setNtEntradaBotellas}
            salidaCajas={ntSalidaCajas}
            setSalidaCajas={setNtSalidaCajas}
            salidaBotellas={ntSalidaBotellas}
            setSalidaBotellas={setNtSalidaBotellas}
            salidaDestino={ntSalidaDestino}
            setSalidaDestino={setNtSalidaDestino}
            invFinalCajas={ntInvFinalCajas}
            setInvFinalCajas={setNtInvFinalCajas}
            invFinalBotellas={ntInvFinalBotellas}
            setInvFinalBotellas={setNtInvFinalBotellas}
            mermas={ntMermas}
            setMermas={setNtMermas}
            observaciones={ntObservaciones}
            setObservaciones={setNtObservaciones}
            handleSaveNoTerminado={handleSaveNoTerminado}
            onCompleteEnvasado={handleCompleteEnvasadoFromNoTerminado}
            onSaveHologramas={handleSaveHologramasFromNoTerminado}
          />
        )}

        {/* SECCIÓN IV: ENVASADO TERMINADO */}
        {activeTab === 2 && (
          <EnvasadoTerminadoSection
            terminadoRecords={terminadoRecords}
          />
        )}

        {/* SECCIÓN V: CONTROL DE HOLOGRAMAS */}
        {activeTab === 3 && (
          <ControlHologramasSection
            hologramaRecords={hologramaRecords}
            terminadoRecords={terminadoRecords}
            isFormOpen={isFormOpen}
            setIsFormOpen={setIsFormOpen}
            idEnvasadoTerminado={hIdEnvasadoTerminado}
            setIdEnvasadoTerminado={setHIdEnvasadoTerminado}
            fechaMovimiento={hFechaMovimiento}
            setFechaMovimiento={setHFechaMovimiento}
            marca={hMarca}
            setMarca={setHMarca}
            loteEnvasado={hLoteEnvasado}
            setLoteEnvasado={setHLoteEnvasado}
            capacidad={hCapacidad}
            setCapacidad={setHCapacidad}
            invInicialRango={hInvInicialRango}
            setInvInicialRango={setHInvInicialRango}
            invInicialCant={hInvInicialCant}
            setInvInicialCant={setHInvInicialCant}
            entradaRango={hEntradaRango}
            setEntradaRango={setHEntradaRango}
            entradaCant={hEntradaCant}
            setEntradaCant={setHEntradaCant}
            salidaRango={hSalidaRango}
            setSalidaRango={setHSalidaRango}
            salidaCant={hSalidaCant}
            setSalidaCant={setHSalidaCant}
            invFinalRango={hInvFinalRango}
            setInvFinalRango={setHInvFinalRango}
            invFinalCant={hInvFinalCant}
            setInvFinalCant={setHInvFinalCant}
            mermasRango={hMermasRango}
            setMermasRango={setHMermasRango}
            mermasCant={hMermasCant}
            setMermasCant={setHMermasCant}
            observaciones={hObservaciones}
            setObservaciones={setHObservaciones}
            handleSaveHologramas={handleSaveHologramas}
          />
        )}

        {/* SECCIÓN VI: ELABORACIÓN DE CLASES */}
        {activeTab === 4 && (
          <ElaboracionClasesSection
            elaboracionRecords={elaboracionRecords}
            granelRecords={effectiveGranelRecords}
            isFormOpen={isFormOpen}
            setIsFormOpen={setIsFormOpen}
            fechaIngreso={elabFechaIngreso}
            setFechaIngreso={setElabFechaIngreso}
            loteOrigen={elabLoteOrigen}
            setLoteOrigen={setElabLoteOrigen}
            volumenOrigen={elabVolumenOrigen}
            setVolumenOrigen={setElabVolumenOrigen}
            pctAlcOrigen={elabPctAlcOrigen}
            setPctAlcOrigen={setElabPctAlcOrigen}
            categoriaOrigen={elabCategoriaOrigen}
            setCategoriaOrigen={setElabCategoriaOrigen}
            claseOrigen={elabClaseOrigen}
            setClaseOrigen={setElabClaseOrigen}
            ingredientesOrigen={elabIngredientesOrigen}
            setIngredientesOrigen={setElabIngredientesOrigen}
            edadOrigen={elabEdadOrigen}
            setEdadOrigen={setElabEdadOrigen}
            analisisOrigen={elabAnalisisOrigen}
            setAnalisisOrigen={setElabAnalisisOrigen}
            tipoMagueyOrigen={elabTipoMagueyOrigen}
            setTipoMagueyOrigen={setElabTipoMagueyOrigen}
            ingredientesAdicionados={elabIngredientesAdicionados}
            setIngredientesAdicionados={setElabIngredientesAdicionados}
            procesoRealizado={elabProcesoRealizado}
            setProcesoRealizado={setElabProcesoRealizado}
            descripcionProceso={elabDescripcionProceso}
            setDescripcionProceso={setElabDescripcionProceso}
            fechaSalida={elabFechaSalida}
            setFechaSalida={setElabFechaSalida}
            loteSalida={elabLoteSalida}
            setLoteSalida={setElabLoteSalida}
            volumenSalida={elabVolumenSalida}
            setVolumenSalida={setElabVolumenSalida}
            pctAlcSalida={elabPctAlcSalida}
            setPctAlcSalida={setElabPctAlcSalida}
            claseSalida={elabClaseSalida}
            setClaseSalida={setElabClaseSalida}
            observaciones={elabObservaciones}
            setObservaciones={setElabObservaciones}
            handleSaveElaboracion={handleSaveElaboracion}
          />
        )}

        {/* SECCIÓN VII: MADURACIÓN */}
        {activeTab === 5 && (
          <InventarioMaduracionSection
            maduracionRecords={maduracionRecords}
            granelRecords={effectiveGranelRecords}
            isFormOpen={isFormOpen}
            setIsFormOpen={setIsFormOpen}
            fechaMovimiento={madFechaMovimiento}
            setFechaMovimiento={setMadFechaMovimiento}
            noLote={madNoLote}
            setMadNoLote={setMadNoLote}
            categoria={madCategoria}
            setMadCategoria={setMadCategoria}
            clase={madClase}
            setMadClase={setMadClase}
            ingredientes={madIngredientes}
            setMadIngredientes={setMadIngredientes}
            edad={madEdad}
            setMadEdad={setMadEdad}
            tipoMaguey={madTipoMaguey}
            setMadTipoMaguey={setMadTipoMaguey}
            noAnalisis={madNoAnalisis}
            setMadNoAnalisis={setMadNoAnalisis}
            tipoRecipiente={madTipoRecipiente}
            setMadTipoRecipiente={setMadTipoRecipiente}
            detalleRecipiente={madDetalleRecipiente}
            setMadDetalleRecipiente={setMadDetalleRecipiente}
            invInicialFecha={madInvInicialFecha}
            setMadInvInicialFecha={setMadInvInicialFecha}
            invInicialRecipientes={madInvInicialRecipientes}
            setMadInvInicialRecipientes={setMadInvInicialRecipientes}
            invInicialVolumen={madInvInicialVolumen}
            setMadInvInicialVolumen={setMadInvInicialVolumen}
            invInicialAlc={madInvInicialAlc}
            setMadInvInicialAlc={setMadInvInicialAlc}
            entradaFolio={madEntradaFolio}
            setMadEntradaFolio={setMadEntradaFolio}
            entradaRecipientes={madEntradaRecipientes}
            setMadEntradaRecipientes={setMadEntradaRecipientes}
            entradaVolumen={madEntradaVolumen}
            setMadEntradaVolumen={setMadEntradaVolumen}
            entradaAlc={madEntradaAlc}
            setMadEntradaAlc={setMadEntradaAlc}
            salidaRecipientes={madSalidaRecipientes}
            setMadSalidaRecipientes={setMadSalidaRecipientes}
            salidaVolumen={madSalidaVolumen}
            setMadSalidaVolumen={setMadSalidaVolumen}
            salidaAlc={madSalidaAlc}
            setMadSalidaAlc={setMadSalidaAlc}
            salidaClaseObtenida={madSalidaClaseObtenida}
            setMadSalidaClaseObtenida={setMadSalidaClaseObtenida}
            salidaEdadObtenida={madSalidaEdadObtenida}
            setMadSalidaEdadObtenida={setMadSalidaEdadObtenida}
            salidaMerma={madSalidaMerma}
            setMadSalidaMerma={setMadSalidaMerma}
            invFinalRecipientes={madInvFinalRecipientes}
            setMadInvFinalRecipientes={setMadInvFinalRecipientes}
            invFinalVolumen={madInvFinalVolumen}
            setMadInvFinalVolumen={setMadInvFinalVolumen}
            invFinalAlc={madInvFinalAlc}
            setMadInvFinalAlc={setMadInvFinalAlc}
            observaciones={madObservaciones}
            setObservaciones={setMadObservaciones}
            handleSaveMaduracion={handleSaveMaduracion}
          />
        )}

        {/* SECCIÓN VIII: CONDICIONES */}
        {activeTab === 6 && (
          <CondicionesMaduracionSection
            condicionesRecords={condionesRecords}
            maduracionRecords={maduracionRecords}
            isFormOpen={isFormOpen}
            setIsFormOpen={setIsFormOpen}
            condMesAnio={condMesAnio}
            setCondMesAnio={setCondMesAnio}
            condNoLote={condNoLote}
            setCondNoLote={setCondNoLote}
            condDailyData={condDailyData}
            setCondDailyData={setCondDailyData}
            condObservaciones={condObservaciones}
            setCondObservaciones={setCondObservaciones}
            handleSaveCondiciones={handleSaveCondiciones}
          />
        )}

        {/* SECCIÓN IX: QUEJAS */}
        {activeTab === 7 && (
          <QuejasSection
            quejasRecords={quejasRecords}
            terminadoRecords={terminadoRecords}
            isFormOpen={isFormOpen}
            setIsFormOpen={setIsFormOpen}
            fechaQueja={fechaQueja}
            setFechaQueja={setFechaQueja}
            noQueja={noQueja}
            setNoQueja={setNoQueja}
            noLote={quejaNoLote}
            setNoLote={setQuejaNoLote}
            descripcionProducto={descripcionProducto}
            setDescripcionProducto={setDescripcionProducto}
            detalleQueja={detalleQueja}
            setDetalleQueja={setDetalleQueja}
            fechaAtencion={fechaAtencion}
            setFechaAtencion={setFechaAtencion}
            medidasCorrectivas={medidasCorrectivas}
            setMedidasCorrectivas={setMedidasCorrectivas}
            handleSaveQueja={handleSaveQueja}
          />
        )}

      </main>
    </div>
  );
};

export default BitacoraEnvasado;